module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"actions.select":"Sélectionner des fichiers","actions.drag.drop":"Ou les glisser directement dans cette zone.","fileList.header":"Fichiers sélectionnés"}}')
  delete Component.options._Ctor
}
